<template>
  <footer class="p-front__footer">
    <ul class="nav">
      <li class="nav-item">
        <a class="nav-link active" href="https://arnergy.surge.sh/contact.html">Contact</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://arnergy.surge.sh/FAQ.html">FAQ</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://arnergy.surge.sh/about.html">About Us</a>
      </li>
            <li class="nav-item">
        <a class="nav-link" href="https://arnergy.surge.sh/products.html">Products and Services</a>
      </li>
    </ul>
    <span>2013 - {{new Date().getFullYear()}} &copy; Arnergy</span>
  </footer>
</template>
<script>
  export default {
    name: 'main-footer',
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/MainFooter.vue